import styled, { css } from "styled-components";
import { color, typeStyle as getTypeStyle, onHover, transition, units, variant } from "@m/alchemy-theme";
import { NakedButton } from "../../naked-button/NakedButton";
import { SortArrowsIcon } from "../../icons/SortArrowsIcon";
import { cellPadding } from "../constants";
import { TableCell } from "../table-cell/TableCell";
const svgSortStyles = variant("sortDirection", {
    none: `
    polyline:last-child {
      opacity: 0.25;
    }
    polyline:first-child {
      opacity: 0.25;
    }
  `,
    descending: `
    polyline:last-child {
      opacity: 1;
    }
    polyline:first-child {
      opacity: 0.25;
    }
  `,
    ascending: `
    polyline:last-child {
      opacity: 0.25;
    }
  `
});
export const SortIcon = styled(SortArrowsIcon) `
  color: ${color("contrast")};
  opacity: 1;
  transition: ${transition("base", "opacity")};
  ${svgSortStyles};
`;
export const SortButton = styled(NakedButton) `
  position: absolute;
  right: 0;
  padding: 0;
  margin: 0;
  bottom: ${units(1.5)};
`;
const SORT_UI_WIDTH = units(3);
export const SortCell = styled(TableCell) `
  padding: 0;
  position: relative;

  &,
  * {
    ${({ typeStyle }) => (typeStyle ? getTypeStyle(typeStyle) : getTypeStyle("bodyM"))};
    text-align: ${({ textAlign }) => textAlign};
    vertical-align: bottom;
  }
`;
export const Content = styled.div `
  display: block;
  margin-bottom: -1px;
  transition: ${transition("base", "border-color")};
  cursor: pointer;
  position: relative;
  padding: ${cellPadding};
  padding-right: ${SORT_UI_WIDTH};

  ${onHover(css `
    ${SortButton}:after {
      opacity: ${({ sortDirection }) => (sortDirection === "none" ? 0.5 : 1)};
    }
  `)}

  &:after {
    position: absolute;
    content: "";
    height: 2px;
    opacity: ${({ sortDirection }) => (sortDirection === "none" ? 0 : 1)};
    background-color: ${color("base")};
    left: 0;
    bottom: 0;
    right: 0;
  }

  ${onHover(css `
    &:after {
      opacity: ${({ sortDirection }) => (sortDirection === "none" ? 0.5 : 1)};
    }
  `)}
`;
